import React, { useEffect, useState } from 'react';
import Process from '../Simulator/VirtualTerminal/Process';
import { DEFAULT_TERMINAL } from '../../Configs';

import overlayImage from "./overlay-image.svg";
import arrow from "./arrow-down.svg"
import plus from "./plus.svg"
import minus from "./minus.svg"
import desktop from "./chrome-ui_desktop.png"
import approved from "../Simulator/VirtualTerminal/Screens/success-icon.svg"
import forward from "./forward.gif"
import reverse from "./reverse.gif"

const WebDemo = props => {

    const [newTransactionForTerminal, setNewTransactionForTerminal] = useState(null);
    const [terminalModel, setTerminalModel] = useState(null);
    const [linkedTerminal, setLinkedTerminal] = useState(true);
    const [connected, setConnected] = useState(true);
    const [showAnimation, setShowAnimation] = useState(false);
    const [animationImage, setAnimationImage] = useState(null)
    const [terminalId, setTerminalId] = useState(DEFAULT_TERMINAL)
    const [shouldMock, setShouldMock] = useState(false)

    const updateSimulationWithResult = (type) => {
        if (type.category == 2) {
            setTimeout(() => {
                setShowAnimation(true);
                setAnimationImage(reverse)
                setTimeout(()=>{
                    setShowAnimation(false);
                    setAnimationImage(null);
                    setShouldMock(true)
                },2000)
            }, 2000)
        }
    }

    const updateTerminalLinkedState = (state) => {
        //
    }

    const updateTerminalConnectedState = (state) => {
        //
    }

    const updateTerminalId = (state) => {
        //
    }

    const restartDemo = () => {
        setShouldMock(false);
    }

    const createPaymentRequest = (state) => {
        var requestNotification = {
            requestBody: {
                amount: 125, // Set the appropriate value for Amount
                currencyCode: 752, // Set the appropriate value for CurrencyCode
                terminalId: DEFAULT_TERMINAL, // Set the appropriate value for TerminalId
                paymentMethod: "" // Set the appropriate value for PaymentMethod
            },
            headers: [], // Fill this array with the appropriate header data
            params: [], // Fill this array with the appropriate query parameters data
            url: "", // Set the appropriate URL
            method: "", // Set the appropriate HTTP method (e.g., "GET" or "POST")
            type: 1, // Set the appropriate transaction type
            identifier: "123456789987456321" // Set the unique identifier as a string
        };
        setShowAnimation(true);
        setAnimationImage(forward)
        setTimeout(()=>{
            setShowAnimation(false);
            setAnimationImage(null);
            setNewTransactionForTerminal(requestNotification);
        }, 1800)
    }

    return (
        <>
            <div className="page-content">
                <div className="demo-store" >
                    <div className="details-area" style={{ backgroundImage: `url(${desktop})`, backgroundRepeat: 'no-repeat', backgroundSize: '1500px' }}>
                        <section class="section-cart desktop">
                            <div class="cart" id="cart">
                                <h4>Shopping cart</h4>
                                <div class="product">
                                    <img class="product-image" src="/assets/images/Hamburger-Cheeseburger.jpg" alt="" style={{ width: "280px", height: "220px" }} />
                                    <span className='url'>www.webecr.com</span>
                                    <div class="product-info">
                                        <h1>Cheeseburger</h1>
                                        <p class="location">Sebastians cheese &amp; wine</p>
                                        <p class="date">May 18, 2022, 21:30</p>
                                        <p class="price">25 SEK/person</p>
                                        <p class="qty">Number of items:
                                            <button class="qty-button minus" disabled="">
                                                <img src={minus} width="10" height="10" />
                                            </button>
                                            <span class="qty-text">5</span>
                                            <button class="qty-button plus" disabled="">
                                                <img src={plus} width="10" height="10" />
                                            </button>
                                        </p>
                                    </div>
                                    <p class="amount"> Total: <span id="totalAmount">125</span> SEK</p>
                                    <div class="payment" style={{ textAlign: 'center' }}>
                                        <a class="btn btn-primary" role="button" aria-disabled="true" onClick={(e) => { createPaymentRequest() }}>Proceed Payment</a>
                                    </div>
                                </div>
                            </div>
                            {shouldMock &&
                                <div className='success-message web'>
                                    <span>Payment Successful</span>
                                    <img src={approved} alt='close' layout="fill" objectFit="fill"></img>
                                </div>
                            }
                        </section>
                    </div>
                    {showAnimation &&
                        <div class="right-data-flow">
                            <img src={animationImage} alt='close' layout="fill" objectFit="fill" style={{ width: '900px ' }}></img>
                        </div>
                    }
                    {false &&
                        <div className='output-area' style={{ backgroundImage: `url(${overlayImage})`, backgroundRepeat: 'no-repeat' }}>
                            <div className='content'>
                                <div className=''>

                                </div>
                                <div className='flow'>
                                    <h5>OnlineAPIRefId : 20231123456563</h5>
                                    <span><img src={arrow}></img></span>
                                    <h5>Once a eCommerce received online api reference id</h5>
                                    <span><img src={arrow}></img></span>
                                    <h5>Should start pooling transaction status request until approved and declinded</h5>
                                    <span><img src={arrow}></img></span>
                                    <h5>Payment complete</h5>
                                </div>
                                <br />
                                <br />
                                <a class="btn btn-primary" role="button" aria-disabled="true" onClick={(e) => { restartDemo() }}>Restart Demo</a>
                            </div>
                        </div>
                    }
                    <div className="demo-area" >
                        <Process
                            newTransaction={newTransactionForTerminal}
                            model={terminalModel}
                            notifySimulatorBackend={(type) => updateSimulationWithResult(type)}
                            linkedTerminal={linkedTerminal}
                            setTerminalLinked={(state) => updateTerminalLinkedState(state)}
                            connected={connected}
                            setConnected={(state) => updateTerminalConnectedState(state)}
                            terminalId={terminalId}
                            setTerminalId={(state) => updateTerminalId(state)}>
                        </Process>
                    </div>
                </div>
            </div>
        </>
    )
}

export default WebDemo;